// extracted by mini-css-extract-plugin
export default {"NoticePanel":"NoticePanel_NoticePanel__Xiofp"};